export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (var k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      var str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

function PrefixInteger(num, length) {
  return (Array(length).join('0') + num).slice(-length)
}
export function getTimeSpanStr1(spanTime) {
  var leave1 = spanTime % (24 * 3600 * 1000)
  var hours = Math.floor(leave1 / (3600 * 1000))
  var leave2 = leave1 % (3600 * 1000)
  var minutes = Math.floor(leave2 / (60 * 1000))
  var leave3 = leave2 % (60 * 1000)
  var seconds = Math.round(leave3 / 1000)
  let ret = ''
  if (hours > 0) {
    ret += PrefixInteger(hours, 2) + ':'
  }
  ret += PrefixInteger(minutes, 2) + ':' + PrefixInteger(seconds, 2)
  return ret
}

export function getTimeSpanStr(spanTime) {
  if (spanTime < 0) {
    return '已过期'
  }
  var days = Math.floor(spanTime / (24 * 3600 * 1000))
  var leave1 = spanTime % (24 * 3600 * 1000)
  var hours = Math.floor(leave1 / (3600 * 1000))
  var leave2 = leave1 % (3600 * 1000)
  var minutes = Math.floor(leave2 / (60 * 1000))
  var leave3 = leave2 % (60 * 1000)
  var seconds = Math.round(leave3 / 1000)
  let ret = ''
  if (days) {
    ret = days + '天'
  }
  if (hours) {
    ret += hours + '小时'
  }
  if (minutes) {
    ret += minutes + '分'
  }
  if (seconds) {
    ret += seconds + '秒'
  }
  return ret
}




// WEBPACK FOOTER //
// ./src/utils/date.js